module.exports = __webpack_public_path__ + "img/header-weddingRingsFacettedConnections.688216d.jpg";